import React from 'react';
import { FaCheck, FaSpinner, FaExclamationTriangle, FaCircle } from 'react-icons/fa';

/**
 * StepProgress — muestra pasos de un proceso largo con estados: pending, running, done, error
 *
 * steps: Array<{ label: string, key: string }>
 * status: Object<key, 'pending'|'running'|'done'|'error'>
 * currentMessage?: string — mensaje extra debajo de los pasos
 */
export default function StepProgress({ steps, status, currentMessage }) {
  const getIcon = (state) => {
    if (state === 'done') return <FaCheck size={12} style={{ color: '#22c55e' }} />;
    if (state === 'error') return <FaExclamationTriangle size={12} style={{ color: '#ef4444' }} />;
    if (state === 'running') return <FaSpinner size={12} className="spin" style={{ color: '#3b82f6' }} />;
    return <FaCircle size={8} style={{ color: '#9ca3af' }} />;
  };

  const getLineColor = (state) => {
    if (state === 'done') return '#22c55e';
    if (state === 'error') return '#ef4444';
    if (state === 'running') return '#3b82f6';
    return '#e5e7eb';
  };

  return (
    <div style={{ padding: '0.6rem 0' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {steps.map((step, idx) => {
          const state = status[step.key] || 'pending';
          const isLast = idx === steps.length - 1;
          return (
            <div key={step.key} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 22 }}>
                <div style={{
                  width: 22, height: 22, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: state === 'done' ? '#dcfce7' : state === 'error' ? '#fee2e2' : state === 'running' ? '#dbeafe' : '#f3f4f6',
                  border: `2px solid ${getLineColor(state)}`, transition: 'all 0.3s ease',
                }}>
                  {getIcon(state)}
                </div>
                {!isLast && (
                  <div style={{
                    width: 2, height: 14, background: getLineColor(state), marginTop: 4, transition: 'all 0.3s ease',
                  }} />
                )}
              </div>
              <div style={{ paddingTop: 2 }}>
                <span style={{
                  fontSize: '0.82rem', fontWeight: state === 'running' ? 600 : 500,
                  color: state === 'done' ? '#16a34a' : state === 'error' ? '#dc2626' : state === 'running' ? '#2563eb' : '#6b7280',
                  transition: 'color 0.3s ease',
                }}>
                  {step.label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {currentMessage && (
        <div style={{ marginTop: 10, fontSize: '0.78rem', color: 'var(--text-secondary)', fontStyle: 'italic' }}>
          {currentMessage}
        </div>
      )}
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .spin { animation: spin 1s linear infinite; }
      `}</style>
    </div>
  );
}
